import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'

import ProjectTypeGroupWidget from '../../../widgets/basicProjectInfo/projectTypeInfo/ProjectTypeGroupWidget'

import SubProjectTypeGroupWidget from '../../../widgets/basicProjectInfo/projectTypeInfo/SubProjectTypeGroupWidget'

import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { getSubProjectProjectType } from '../../../redux/actions/projectType'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'

import { startLoading, doneLoading } from '../../../utils/loading'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import './styles.less'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'

export default function ProjectTypeInfoView() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [showEditAll, setShowEditAll] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSubProjectProjectType(projectId)
      // console.log('_________ schema ', _schema)
      setSchema(_schema)
      setIsEditWidget({
        projectTypeInfo: _schema.forms?.projectTypeInfo?.id ? false : true,
      })
      let projectTypeInfo = _schema?.forms?.projectTypeInfo
        ? !_schema.forms.projectTypeInfo.disabled
        : true
      setShowEditAll(projectTypeInfo)
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isSubProject>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      {showEditAll && (
        <BtnEditAll
          onClickEditAll={getIsEditAll(isEditWidget)}
          setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
        />
      )}

      {schema?.forms?.projectTypeInfo && (
        <SubProjectTypeGroupWidget
          showCommandButton={!schema.forms.projectTypeInfo.disabled}
          schema={schema.forms.projectTypeInfo}
          isEdit={isEditWidget.projectTypeInfo}
          onChangeIsEdit={(_isEdit) =>
            handleOnChangeIsEdit('projectTypeInfo', _isEdit, setIsEditWidget)
          }
        />
      )}
    </SidebarProposal>
  )
}
